module.exports = "## Icon Menu\n\n[Icon Menus](https://www.google.com/design/spec/components/menus.html#menus-usage)\nare menus that open from icons. They can give options related to the icon and use\na minimal space.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/IconMenu/README.md
 ** module id = 1004
 ** module chunks = 0
 **/